module.exports = __webpack_public_path__ + "static/img/jzz.1d487b7b.png";